import "./New.css";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import { useState, useEffect } from "react";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db, storage } from "../../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

import { openai } from "../../firebase";

const New = ({ inputs, title, type }) => {
  const [file, setFile] = useState("");
  const [data, setData] = useState({});
  const [per, setPerc] = useState(null);

  useEffect(() => {
    const uploadFile = () => {
      const name = new Date().getTime() + file.name;

      const storageRef = ref(storage, file.name);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          setPerc(progress);
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
            default:
              break;
          }
        },
        (error) => {
          console.log(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            setData((prev) => ({ ...prev, img: downloadURL }));
          });
        }
      );
    };
    file && uploadFile();
  }, [file]);

  const handleInput = (e) => {
    const id = e.target.id;
    let value = e.target.value;

    if (value === "true") value = true;
    if (value === "false") value = false;

    setData({ ...data, [id]: value });
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      const collectionT = type !== "users" ? "posts" : "users";

      const documentData = {
        ...data,
        timestamp: serverTimestamp(),
      };

      if (type !== "users") {
        if (!documentData.firstName || !documentData.lastName) {
          documentData.isAnonymous = true;
        }
        documentData[type] = true;

        let information = "";
        if (type === "isActivity") {
          information = `${documentData.activity} ${documentData.significance}  ${documentData.memory} ${documentData.advice}`;
        } else if (type === "isJob") {
          information = `${documentData.employer} ${documentData.purpose}  ${documentData.advice} `;
        } else if (type === "isAcademic") {
          information = `${documentData.academicGoal} ${documentData.ib} ${documentData.course}  ${documentData.teacher}  ${documentData.value} ${documentData.relatedActs}`;
        } else if (type === "isCollege") {
          information = `${documentData.research} ${documentData.fairs}  ${documentData.knownEarlier}  ${documentData.selection} ${documentData.regrets} ${documentData.essayApproach}`;
        } else if (type === "isSocial") {
          information = `${documentData.advice}`;
        }

        let quotePrompt = "In 20 words or less, find the most interesting, unique, and compelling quote from the paragraph below. Make the quote logical, make sense, and grammatically correct";

        const completion = await openai.createChatCompletion({
          model: "gpt-3.5-turbo",
          temperature: 0,
          max_tokens: 75,
          top_p: 1,
          frequency_penalty: 0,
          presence_penalty: 0,
          messages: [{
            role: "system",
            content: "You are a professional and helpful editor following Modern Language Association standards"
              }, { role: "user", content: `${quotePrompt}\n\n${information}` }],
        });

        const quote = completion["data"]["choices"][0]["message"]["content"];
        console.log(quote);
        // Add the quote to the documentData object
        documentData.quote = quote;

        let num = "";
        const rankPrompt =
          'please score this piece of advice on a scale from 0-600 in terms of its amount of detail higher the better, uniqueness higher the better, and helpfulness higher the better. Please only output the "total score" number by itself. As an example, this response is an average response and scores a 353 -> IB Physics will really push you to become a critical thinker. I would recommend it because even though it can be difficult and challenging, it pushes you to be a better learner in general and appreciate different types of knowledge.	Vickery	Vickery is a phenomenal teacher and pushing my self-defined academic limits was life changing. I have never worked so hard in any class, and for that I am thankful for the experience. It is humbling, but also exciting to realize how much knowledge is just out there ready to be studied and discovered. 	I studies for hours a day. Like all the time. And now I see physics everywhere I look.          This response gets a 525 ->(Your idea of a perfect college is probably going to change throughout the year, so don\'t worry if you don\'t know what aspects are most important to you at first. They will come up and as you look at and hear more about more colleges you\'ll notice what things stick out to you.	Yes! Visiting and being at a college is always the most helpful thing so you can determine whether or not you can really see yourself there.	I wish that someone told me to not focus on colleges the whole year. You still have a senior year to enjoy and once you know where you\'re going you know where you\'re going. It\'s easy to make college the topic of every conversation, but I would advise against all the speculation since at the end of the day there is very little that you have control over after you submit applications.	Because the school I chose is in a city that I\'ve been to a lot, it felt like it would already feel like a home away from home. Plus, my Grandma lives in Boston so I knew that I could be around family. Also, Harvard was definitely a top choice!	Like I mentioned earlier, focusing less on speculation and more on	I did procrastinate, but I honestly don\'t regret that too much because it allowed me to wait until times that I felt particularly inspired to write my essays. I would definitely make sure that you have a positive attitude and excited mindset during the times that you choose to write. You definitely want to be feeling extra genuine in those moments.) This response gets a 30   (Lunch  Tasty  Had an apple once  Apples are good)';

        const rank = async (input) => {
          const response = await openai.createChatCompletion({
            model: "gpt-3.5-turbo",
            temperature: 0,
            messages: [{
              role: "system",
              content: "You are a professional critic ranking pieces of advice"
                }, { role: "user", content: input }],
          });

          const rank = response["data"]["choices"][0]["message"]["content"];
          num = rank.replace("Total score: ", "").replace("total score: ", "").replace("This response gets a ", "");

        };

        await rank(`${rankPrompt}\n\n${information}`);
        documentData.rank = num;
      }
      await addDoc(collection(db, collectionT), documentData);
      console.log(documentData.rank);
      window.location.reload();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="new">
      <div className="newContainer">
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="left">
            {type === "users" && (
              <img
                src={
                  file
                    ? URL.createObjectURL(file)
                    : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
                }
                alt=""
              />
            )}
          </div>
          <div className="right">
            <form onSubmit={handleAdd}>
              {type === "users" && (
                <div className="formInput">
                  <label htmlFor="file">
                    Image: <DriveFolderUploadOutlinedIcon className="icon" />
                  </label>
                  <input
                    type="file"
                    id="file"
                    onChange={(e) => setFile(e.target.files[0])}
                    style={{ display: "none" }}
                  />
                  <div onChange={handleInput}>
                    <label>Were you in IB Diploma?</label>
     
                      <input id = "isIb" value="true" type="radio" name="ib"  />Yes

                      <input id = "isIb" value="false" type="radio" name="ib" />No

                  </div>

                  <div onChange={handleInput}>
                    <label>Were you in IB Certificate?</label>
     
                      <input id = "isIbCert" value="true" type="radio" name="cert"  />Yes

                      <input id = "isIbCert" value="false" type="radio" name="cert" />No

                  </div>
                  
                </div>
              )}

              {inputs.map((input) => (
                <div className="formInput" key={input.id}>
                  <label>{input.label}</label>
                  <input
                    id={input.id}
                    type={input.type}
                    placeholder={input.placeholder}
                    onChange={handleInput}
                  />
                </div>
              ))}
              <button disabled={per < 100 && per > 0} type="submit">
                Send
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default New;
